var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-link",attrs:{"to":_vm.toEvent},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var navigate = ref.navigate;
var href = ref.href;
return [_c('base-button-render',_vm._b({attrs:{"tag":"a","href":href,"download":"","icon":_vm.iconProps,"meta":_vm.meta},on:{"click":navigate}},'base-button-render',_vm.$attrs,false))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }